/**
 * Runder Avatar mit Initialen.
 *
 * Kein Bild von außen — auch kein „Platzhalter-Dienst". Ein Avatar, der von
 * einem fremden Server käme, wäre eine Meldung nach außen bei jedem Blick in
 * die Familienliste, und genau das soll diese App nicht tun.
 *
 * Der Kreis ist `aria-hidden`: Direkt daneben steht der Name im Klartext.
 * Ein Screenreader, der erst „L E" und dann „Lena" vorliest, ist langsamer,
 * nicht barrierefreier.
 */

/**
 * Höchstens zwei Buchstaben — „Anna-Maria Schmidt" wird zu „AS".
 *
 * Nimmt bewusst auch `null` und `undefined` an. Ein Raumtitel ist im
 * Datenmodell `string | null` (bei Direktchats steht der Name nicht am Raum,
 * sondern ergibt sich aus den Mitgliedern), und ein Avatar, der die App zum
 * Absturz bringt, weil ein Name fehlt, ist schlimmer als ein Fragezeichen.
 * Genau das ist beim Umbau passiert: Die Anrufliste warf, sobald ein
 * Zweiergespräch darin stand.
 */
export function initialen(name: string | null | undefined): string {
  const teile = (name ?? '').trim().split(/[\s-]+/).filter(Boolean)
  if (teile.length === 0) return '?'
  const erste = teile[0]![0] ?? ''
  const letzte = teile.length > 1 ? teile[teile.length - 1]![0] ?? '' : ''
  return (erste + letzte).toUpperCase()
}

export function Avatar({ name, gross, symbol }: {
  name: string | null | undefined
  gross?: boolean
  /** Statt Initialen ein Symbol — für den Familienchat, der keine Person ist. */
  symbol?: string | undefined
}) {
  return (
    <span class={`fh-avatar${gross ? ' fh-avatar--gross' : ''}`} aria-hidden="true">
      {symbol ?? initialen(name)}
    </span>
  )
}
